import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { FaChevronDown, FaSearch } from 'react-icons/fa';
import './SearchableSelect.scss';
// A compact combobox that filters its options by a typed query — built for lists
// too long to scroll (thousands of creators/challenges). Native <select> can't
// search-filter; this can.
function SearchableSelect({ options, value, onChange, allLabel, placeholder = 'Search…', disabled }) {
    var _a, _b;
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const ref = useRef(null);
    const selectedLabel = value === null ? allLabel : ((_b = (_a = options.find(o => o.value === value)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : allLabel);
    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        return q ? options.filter(o => o.label.toLowerCase().includes(q)) : options;
    }, [options, query]);
    useEffect(() => {
        if (!open)
            return;
        const onDown = (e) => {
            if (ref.current && !ref.current.contains(e.target))
                setOpen(false);
        };
        document.addEventListener('mousedown', onDown);
        return () => document.removeEventListener('mousedown', onDown);
    }, [open]);
    const pick = (next) => {
        onChange(next);
        setOpen(false);
        setQuery('');
    };
    return (_jsxs("div", { className: `searchable-select ${open ? 'open' : ''}`, ref: ref, children: [_jsxs("button", { type: "button", className: "ss-control", disabled: disabled, onClick: () => setOpen(o => !o), "aria-haspopup": "listbox", "aria-expanded": open, children: [_jsx("span", { className: `ss-value ${value === null ? 'is-all' : ''}`, children: selectedLabel }), _jsx(FaChevronDown, { className: "ss-arrow" })] }), open && (_jsxs("div", { className: "ss-popover", children: [_jsxs("div", { className: "ss-search", children: [_jsx(FaSearch, { className: "ss-search-icon" }), _jsx("input", { autoFocus: true, value: query, onChange: (e) => setQuery(e.target.value), placeholder: placeholder })] }), _jsxs("ul", { className: "ss-list", role: "listbox", children: [_jsx("li", { className: `ss-option ${value === null ? 'selected' : ''}`, role: "option", "aria-selected": value === null, onClick: () => pick(null), children: allLabel }), filtered.map(o => (_jsx("li", { className: `ss-option ${o.value === value ? 'selected' : ''}`, role: "option", "aria-selected": o.value === value, title: o.label, onClick: () => pick(o.value), children: o.label }, o.value))), filtered.length === 0 && _jsx("li", { className: "ss-empty", children: "No matches" })] })] }))] }));
}
export default SearchableSelect;
